import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { Preset } from '@primeng/themes/types';

import { baseTheme } from '../shared/base-theme';

/** 4-H org — green primary ramp. */
export const FourHPreset: Preset<any> = definePreset(Material, {
  ...baseTheme,
  semantic: {
    ...baseTheme.semantic,
    primary: {
      50: '#f5faf7',
      100: '#cfe7db',
      200: '#a8d3be',
      300: '#82c0a1',
      400: '#5bac84',
      500: '#359967',
      600: '#2d8258',
      700: '#256b48',
      800: '#1d5439',
      900: '#153d29',
      950: '#0d261a'
    }
  }
});
